import { Input, ChangeDetectorRef } from '@angular/core';

export class AbstractWidgetComponent {
  @Input() item: any;

  protected _preview: boolean;
  @Input() set preview(status: boolean) {
    this._preview = status;
    if (this.ref && this.ref.detectChanges) {
      this.ref.detectChanges();
    }
  }

  constructor(protected ref: ChangeDetectorRef) { }

  get meta() {
    return this.item && this.item.meta || {};
  }

  getConfig(key: string) {
    return this.meta[key] || (<any>this.constructor)[key.toUpperCase()];
  }

  get title() {
    return this.getConfig('title');
  }

  get icon() {
    return this.getConfig('icon');
  }

  get plainHtml() {
    return this.getConfig('plainHtml');
  }

  get description() {
    return this.getConfig('description');
  }

  get configuration() {
    return this.getConfig('configuration');
  }

  get options() {
    return this.getConfig('options');
  }

  get preview() {
    return this._preview;
  }

  sanitizeData(raw?: boolean) {
    const obj = {
      name: this.constructor.name,
      title: this.title,
      description: this.description,
      icon: this.icon,
      configuration: this.configuration,
      plainHtml: this.plainHtml,
      options: this.options || {},
    };
    return raw ? obj : JSON.stringify(obj);
  }

  dragStartHandler(ev, options?: Object) {
    ev.dataTransfer.setData('widgetData', this.sanitizeData());
    if (options) {
      ev.dataTransfer.setData('options', JSON.stringify(options));
    }
  }
}
